export enum EddStatus {
  OPEN = "OPEN",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING_L1 = "PENDING_L1",
  PENDING_L2 = "PENDING_L2",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  SUSPENDED = "SUSPENDED",
}

export enum EddTriggerReason {
  PEP = "PEP",
  PEP_WITH_SANCTIONED_COUNTRY = "PEP_WITH_SANCTIONED_COUNTRY",
  HIGH_RISK = "HIGH_RISK",
  KYB_HIGH_RISK = "KYB_HIGH_RISK",
  MANUAL = "MANUAL",
  ESCALATION_L1 = "ESCALATION_L1",
  RE_KYC_TRIGGER = "RE_KYC_TRIGGER",
  TRANSACTION_ALERT = "TRANSACTION_ALERT",
  UNKNOWN = "UNKNOWN",
}

// Values mirror the backend EddDocumentType enum (see /compliance/edd addDocument).
export enum EddDocumentType {
  IDENTITY = "IDENTITY",
  SOURCE_OF_FUNDS = "SOURCE_OF_FUNDS",
  BUSINESS_ACTIVITY = "BUSINESS_ACTIVITY",
  BENEFICIAL_OWNER = "BENEFICIAL_OWNER",
  OTHER = "OTHER",
}

// Risk re-assessment recorded at L2 approval (backend ApproveL2Request.riskAssessment).
export enum EddRiskAssessment {
  MAINTAINED = "MAINTAINED",
  UPGRADED = "UPGRADED",
  DOWNGRADED = "DOWNGRADED",
}

export interface EddCaseSummary {
  caseId: string;
  businessKey: string;
  status: EddStatus;
  triggerReason: EddTriggerReason;
  assignedAnalyst: string | null;
  createdAt: string;
  slaDeadline: string | null;
  firstName: string | null;
  lastName: string | null;
  /** Personne physique (KYC) ou entreprise (KYB) ; null si le client n'a pas pu être résolu. */
  customerType?: string | null;
  /** Raison sociale quand le client est une entreprise (firstName/lastName sont alors son déclarant). */
  companyName?: string | null;
}

export interface EddCaseDetail extends EddCaseSummary {
  submittedAt: string | null;
  l1ApprovedBy: string | null;
  l2ApprovedBy: string | null;
  decisionNotes: string | null;
}

// Résultat du challenge MFA (#24704) déclenché avant une décision 4-yeux : un OTP est
// envoyé à l'email du décideur ; on n'affiche que l'email masqué et la durée de validité.
export interface EddMfaChallenge {
  sentTo: string;
  ttlMinutes: number;
  /** Renseigné seulement en environnement de test : aucun mail réel n'est parti, c'est le code à saisir. */
  testCode?: string;
}

export interface EddDocument {
  documentId: string;
  type: EddDocumentType;
  fileName: string;
  comment: string | null;
  uploadedBy: string;
  uploadedAt: string;
  mimeType: string | null;
  sizeBytes: number | null;
}

export interface EddHistoryEntry {
  timestamp: string;
  actor: string;
  action: string;
  fromStatus: EddStatus | null;
  toStatus: EddStatus | null;
  note: string | null;
}
